import { useCallback } from 'react';
import type { PromotionsBanner } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogClickShortBanner = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(
    (banner: PromotionsBanner) => {
      logGoodsAnalytics({
        name: 'CLICK_SHORT_BANNER',
        analytics: {
          SCREEN: 'GOODS_DETAIL',
          EVENT_TYPE: 'CLICK_SHORT_BANNER',
          // GROUP_SNO:banner.
          ...banner.logging.analytics,
        },
      });
    },
    [logGoodsAnalytics],
  );
};
